module.exports = __webpack_public_path__ + "static/media/Lys-min.5c7637ea.PNG";